module.exports = __webpack_public_path__ + "static/media/Misfits.3a404246.mp4";